/* Surfpaints v4.4 (21 Oct 2026, Danny): B2B exit-intent quote pop-up + "Download our price list" CTAs.
   Used only on /pages/wholesale-sign-up, /pages/wholesale-order (stockist <sp-pl-quote>) and the bulk/schools product page
   (class-pack <spb-quote>). The pop-up MOVES the page's existing quote form into a dialog (no second copy of the form, same
   required fields, same contact-form lead to support@) and puts it back on close, leaving a same-height placeholder so the
   page never shifts.
   Triggers: desktop (fine pointer) = mouse leaves through the top of the window; touch = fast scroll-up after reaching 60% of
   the page, or 28 s on the page after the visitor has scrolled. No history/back-button tricks.
   Never: twice per session, within 7 days of a dismiss/submit, after any quote download/lead, with items in the cart or after a
   checkout/cart click, while typing, while the form is already open/on screen, while another dialog is open.
   Touches no other widget's inline styles (the SmartReply bubble is only hidden by a stylesheet class while the dialog is open). */
(function () {
  if (window.__spExitQ) return; window.__spExitQ = 1;
  var DAY = 864e5, K_DONE = 'sp_quote_done', K_UNTIL = 'sp_exitq_until', S_SHOWN = 'sp_exitq_shown', S_CO = 'sp_exitq_checkout';
  var L = function (k, v) { try { if (v === undefined) return localStorage.getItem(k); localStorage.setItem(k, String(v)); } catch (e) { return null; } };
  var S = function (k, v) { try { if (v === undefined) return sessionStorage.getItem(k); sessionStorage.setItem(k, String(v)); } catch (e) { return null; } };
  var now = function () { return Date.now(); };
  var markDone = function () { L(K_DONE, now()); L(K_UNTIL, now() + 7 * DAY); };
  window.spExitQuoteDone = markDone;

  /* Any quote/lead from the existing forms (both classes fire these) = done for good. */
  document.addEventListener('spb:lead', markDone);
  document.addEventListener('spb:quote', markDone);
  if (/[?&]contact_posted=true/.test(location.search)) markDone();
  document.addEventListener('submit', function (e) { var f = e.target, a = (f && f.getAttribute && f.getAttribute('action')) || ''; if (/\/contact|\/account/.test(a) || (f.classList && f.classList.contains('spb-lead-form'))) markDone(); }, true);
  /* Heading to cart/checkout (links, checkout buttons, express buttons, "Order these now", wholesale "Check out"). */
  document.addEventListener('click', function (e) {
    var t = e.target && e.target.closest && e.target.closest('a[href*="/checkout"],a[href*="/cart"],[name="checkout"],[data-spb-order],[data-a="checkout"],[data-a="cart"],[data-o="mail"],a[href^="mailto:"],.shopify-payment-button,[data-sp-express],form[action*="/cart"] [type="submit"]');
    if (t) S(S_CO, '1');
  }, true);

  /* ---------- CTA row ("Download our price list" / "Or select your products…") ---------- */
  var openInline = function (el, mode, btn) {
    if (!el) return;
    var wrap = el.closest('[data-sppl-wrap]');
    el.hidden = false;
    if (wrap) wrap.querySelectorAll('[data-sppl-cta],[data-sppl-open]').forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
    prep(el, mode);
    setTimeout(function () {
      var f = mode === 'list' ? el.querySelector('[name="org"]') : el.querySelector('[data-sppl-lines] input');
      (mode === 'list' ? (el.querySelector('.spb-qfields') || el) : el).scrollIntoView({ behavior: 'smooth', block: 'start' });
      if (f) try { f.focus({ preventScroll: true }); } catch (x) { f.focus(); }
    }, 40);
  };
  var prep = function (el, mode) {
    if (!el.lines) return;
    if (mode === 'list') {
      el.lines.forEach(function (l) { l.qty = 0; });
      if (el.renderLines) el.renderLines(); if (el.update) el.update();
      if (el.msg) el.msg('Full price list: leave the quantities blank and add your details below.');
    } else if (el.pullOrder) el.pullOrder();
  };
  document.addEventListener('click', function (e) {
    var b = e.target && e.target.closest && e.target.closest('[data-sppl-cta]');
    if (!b) return;
    var el = document.getElementById(b.getAttribute('aria-controls'));
    if (!el) return;
    if (modal && modal.contains(b)) return;
    openInline(el, b.getAttribute('data-sppl-cta'), b);
  });

  /* ---------- Exit-intent dialog ---------- */
  var modal = document.querySelector('[data-sp-exitq]');
  if (!modal) return;
  var cfg = {}; try { cfg = JSON.parse(modal.getAttribute('data-sp-exitq') || '{}'); } catch (e) {}
  if (cfg.wholesale) return;
  if (/spq=/.test(location.hash) || /[?&]view=/.test(location.search)) return;
  var body = modal.querySelector('[data-sp-exitq-body]'), closeBtn = modal.querySelector('[data-sp-exitq-close]'), box = modal.querySelector('[data-sp-exitq-box]');
  var target = function () { try { return document.querySelector(cfg.target); } catch (e) { return null; } };
  var t0 = now(), scrolled = false, armed = false, fired = false, isOpen = false, marker = null, ph = null, prevFocus = null, wasHidden = false, cartCache = null;

  var visible = function (el) { if (!el) return false; var r = el.getBoundingClientRect(); return r.bottom > 60 && r.top < (window.innerHeight || 800) - 60 && r.height > 0; };
  var otherDialog = function () {
    var d = document.querySelectorAll('[aria-modal="true"],[role="dialog"]:not([hidden]),dialog[open]');
    for (var i = 0; i < d.length; i++) { if (modal.contains(d[i]) || d[i] === modal) continue; var r = d[i].getBoundingClientRect(), cs = getComputedStyle(d[i]); if (r.width > 40 && r.height > 40 && cs.visibility !== 'hidden' && cs.display !== 'none' && cs.opacity !== '0') return true; }
    return false;
  };
  var blocked = function () {
    if (fired || isOpen) return 'fired';
    if (L(K_DONE)) return 'done';
    var u = parseInt(L(K_UNTIL) || '0', 10); if (u && u > now()) return 'snoozed';
    if (S(S_SHOWN)) return 'session';
    if (S(S_CO)) return 'checkout';
    if (document.visibilityState === 'hidden') return 'hidden';
    var a = document.activeElement; if (a && a !== document.body && /^(INPUT|TEXTAREA|SELECT)$/.test(a.tagName)) return 'typing';
    var el = target(); if (!el) return 'no-form';
    if (cfg.mode === 'pl' ? !el.hidden : visible(el)) return 'form-open';
    if (otherDialog()) return 'dialog';
    return '';
  };
  var cartCount = function () {
    if (cartCache && now() - cartCache.t < 15000) return Promise.resolve(cartCache.n);
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return Promise.race([
      fetch(root + 'cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (j) { cartCache = { t: now(), n: j.item_count || 0 }; return cartCache.n; }),
      new Promise(function (res) { setTimeout(function () { res(cfg.cart || 0); }, 1200); })
    ]).catch(function () { return cfg.cart || 0; });
  };
  var trigger = function (why) {
    if (blocked()) return;
    cartCount().then(function (n) {
      if (n > 0) { S(S_CO, '1'); return; }
      if (blocked()) return;
      open(why);
    });
  };
  var focusables = function () { return Array.prototype.filter.call(box.querySelectorAll('a[href],button:not([disabled]),input:not([disabled]):not([type=hidden]),select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])'), function (x) { return x.offsetParent !== null || x === closeBtn; }); };
  var onKey = function (e) {
    if (!isOpen) return;
    if (e.key === 'Escape' || e.key === 'Esc') { e.preventDefault(); close('esc'); return; }
    if (e.key !== 'Tab') return;
    var f = focusables(); if (!f.length) return;
    var first = f[0], last = f[f.length - 1], a = document.activeElement;
    if (!box.contains(a)) { e.preventDefault(); first.focus(); return; }
    if (e.shiftKey && a === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && a === last) { e.preventDefault(); first.focus(); }
  };
  var open = function (why) {
    var el = target(); if (!el) return;
    fired = true; isOpen = true; S(S_SHOWN, '1');
    prevFocus = document.activeElement;
    wasHidden = !!el.hidden;
    marker = document.createComment('sp-exitq'); el.parentNode.insertBefore(marker, el);
    var h = wasHidden ? 0 : el.offsetHeight;
    if (h) { ph = document.createElement('div'); ph.setAttribute('aria-hidden', 'true'); ph.style.setProperty('display', 'block', 'important'); ph.style.height = h + 'px'; /* Dawn hides div:empty */ marker.parentNode.insertBefore(ph, marker); }
    body.appendChild(el);
    el.hidden = false;
    if (cfg.mode === 'pl') prep(el, 'quote');
    modal.hidden = false;
    document.documentElement.classList.add('sp-exitq-open');
    modal.setAttribute('data-why', why);
    requestAnimationFrame(function () { modal.classList.add('is-in'); });
    try { (modal.querySelector('[data-sp-exitq-title]') || closeBtn).focus({ preventScroll: true }); } catch (x) { closeBtn.focus(); }
    document.addEventListener('keydown', onKey, true);
    try { document.dispatchEvent(new CustomEvent('sp:exitq', { detail: { action: 'open', why: why, page: cfg.page } })); } catch (x) {}
    if (window.clarity) try { window.clarity('event', 'sp_exitq_open'); } catch (x) {}
  };
  var close = function (how) {
    if (!isOpen) return;
    isOpen = false;
    var el = target() || body.firstElementChild;
    if (el && marker && marker.parentNode) { marker.parentNode.insertBefore(el, marker); if (cfg.mode === 'pl' && wasHidden) el.hidden = true; }
    if (marker && marker.parentNode) marker.parentNode.removeChild(marker); marker = null;
    if (ph && ph.parentNode) ph.parentNode.removeChild(ph); ph = null;
    modal.classList.remove('is-in'); modal.hidden = true;
    document.documentElement.classList.remove('sp-exitq-open');
    document.removeEventListener('keydown', onKey, true);
    if (!L(K_DONE)) L(K_UNTIL, now() + 7 * DAY);
    if (prevFocus && prevFocus.focus && document.contains(prevFocus)) try { prevFocus.focus({ preventScroll: true }); } catch (x) {}
    try { document.dispatchEvent(new CustomEvent('sp:exitq', { detail: { action: 'close', how: how, page: cfg.page } })); } catch (x) {}
  };
  window.spExitQuote = { open: function () { open('manual'); }, close: close, blocked: blocked, trigger: trigger };
  closeBtn.addEventListener('click', function () { close('button'); });
  modal.addEventListener('click', function (e) { if (e.target === modal) close('backdrop'); });
  /* Background must not scroll behind the dialog; done on the overlay only (no body/html style changes = no layout shift). */
  var stop = function (e) { if (!box.contains(e.target)) e.preventDefault(); };
  modal.addEventListener('wheel', stop, { passive: false });
  modal.addEventListener('touchmove', stop, { passive: false });

  var fine = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  if (fine) {
    document.addEventListener('mouseout', function (e) {
      if (e.relatedTarget || e.toElement) return;
      if (e.clientY > 8) return;
      if (now() - t0 < 4000) return;
      trigger('desktop-exit-top');
    });
  } else {
    var lastY = window.scrollY || 0, lastT = now(), upFrom = null, sh = 0, shT = 0, raf = 0;
    /* A tap on a link/button (e.g. the sticky bar's "Custom quote" or "back to top") scrolls the page itself: not an exit signal. */
    var lastTap = 0; document.addEventListener('click', function () { lastTap = now(); }, true); window.addEventListener('hashchange', function () { lastTap = now(); });
    var onScroll = function () {
      raf = 0;
      var y = window.scrollY || window.pageYOffset || 0, t = now();
      if (!sh || t - shT > 1000) { sh = document.documentElement.scrollHeight; shT = t; }
      if (Math.abs(y - lastY) > 20) scrolled = true;
      if (!armed && (y + window.innerHeight) / Math.max(sh, 1) >= 0.6) armed = true;
      if (y < lastY) { if (upFrom === null || t - upFrom.t > 350) upFrom = { y: lastY, t: t }; if (armed && upFrom.y - y >= 220 && t - upFrom.t <= 350 && t - lastTap > 2500) { upFrom = null; trigger('mobile-fast-scroll-up'); } }
      else upFrom = null;
      lastY = y; lastT = t;
    };
    window.addEventListener('scroll', function () { if (!raf) raf = requestAnimationFrame(onScroll); }, { passive: true });
    var dwell = (cfg.dwell || 28) * 1000;
    var tick = function () { if (fired) return; if (scrolled) trigger('mobile-dwell'); setTimeout(tick, 3000); };
    setTimeout(tick, dwell);
  }
})();
